import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ROUTES } from '../App';
import { useUser } from '../contexts/UserContext';

const GuestRoute = () => {
    const { currentUser, loading } = useUser();
    const location = useLocation();

    if (loading) {
        // full-screen spinner
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-[#1A1A1A] z-50">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-black dark:border-white"></div>
            </div>
        );
    }

    if (currentUser) {
        // Check for redirect query param
        const queryParams = new URLSearchParams(location.search);
        const redirectPath = queryParams.get("redirect") || ROUTES.DASHBOARD; // default to dashboard

        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />; // render SignIn / SignUp
};

export default GuestRoute;

const ProtectedRoute = () => {
    const { currentUser, loading } = useUser();
    const location = useLocation();

    if (loading) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-[#1A1A1A] z-50">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-black dark:border-white"></div>
            </div>
        );
    }

    if (!currentUser) {
        const redirectPath = `${location.pathname}${location.search}${location.hash}`;
        return (
            <Navigate
                to={`${ROUTES.SIGN_IN}?redirect=${encodeURIComponent(redirectPath)}`}
                replace
            />
        );
    }

    return <Outlet />;
};

const AdminRoute = () => {
    const { currentUser, loading } = useUser();
    const location = useLocation();

    if (loading) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-[#1A1A1A] z-50">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-black dark:border-white"></div>
            </div>
        );
    }

    if (!currentUser) {
        const redirectPath = `${location.pathname}${location.search}${location.hash}`;
        return (
            <Navigate
                to={`${ROUTES.SIGN_IN}?redirect=${encodeURIComponent(redirectPath)}`}
                replace
            />
        );
    }

    if (!currentUser.isAdmin) {
        return (
            <Navigate
                to={`${ROUTES.DASHBOARD}`}
                replace
            />
        );
    }

    return <Outlet />;
};

export { GuestRoute, ProtectedRoute, AdminRoute };